<svelte:options customElement={{ tag: "bt-pagination-footer", shadow: "none", }} />

<script lang="ts">
	import ActionButton from '$shared/action-button/ActionButton.svelte'
	import Icon from '$shared/icons/Icon.svelte';
	import { eventBus } from '$shared/lib/eventBus';
	export let previousButtonText: string = 'Previous';
	export let previousItemTitle: string = '';
	export let previousItemURL: string = '';
	export let nextButtonText: string = 'Next';
	export let nextItemTitle: string = '';
	export let nextItemURL: string = '';
	export let nextItemTypeTranslation: string = '';
	export let nextItemKlass: string = '';
	export let nextItemDuration: string = '';
	export let collectionLength: string | number = '';
	export let itemPosition: string | number = '';
	export let nextItemDataReceived: boolean = false;
	// Force type number for numberlike strings
	collectionLength = +collectionLength;
	itemPosition = +itemPosition;

	eventBus.on('autoplay-next-received', (event) => {
		nextItemDataReceived = event.nextReceived;
	});

	let emitNextDataCount = 0;
	const emitNextDataInterval = setInterval(() => {
		if (nextItemURL) {
			eventBus.emit('autoplay-next', {
				nextData: {
					klass: nextItemKlass,
					type: nextItemTypeTranslation,
					title: nextItemTitle,
					duration: nextItemDuration,
					URL: `${window.location.protocol}//${window.location.host}${nextItemURL}`
				}
			});
		}

		emitNextDataCount += 1;

		if (nextItemDataReceived || emitNextDataCount > 5) {
			clearInterval(emitNextDataInterval);
		}
	}, 200)
</script>

<section class="pagination-footer">
	<div>
		{#if previousItemTitle || previousItemURL}
			<ActionButton buttonClasses="relative" design="secondary">
				<Icon icon="ChevronFirst" iconClass="!ml-0"></Icon>
				<a href={previousItemURL}>
					<span>{previousButtonText}: {previousItemTitle}</span>
				</a>
			</ActionButton>
		{/if}
	</div>
	<span>{itemPosition} of {collectionLength}</span>
	<div>
		{#if nextItemTitle || nextItemURL}
			<ActionButton buttonClasses="!grow-0 relative" design="primary">
				<a href={nextItemURL}>
					<span>{nextButtonText}: {nextItemTitle}</span>
				</a>
				<Icon icon="ChevronLast" iconClass="max-sm:!ml-0"></Icon>
			</ActionButton>
		{/if}
	</div>
</section>

<style>
	:global(bt-pagination-footer) {
		display: block;
		position: sticky;
		bottom: 0;
		grid-column: span 4;
		z-index: 30;
	}
	:global(.pagination-footer .action-button) {
		max-width: 16rem;
	}
	section {
		height: 4.5rem;
		width: 100%;
		display: grid;
		background: white;
		grid-template-columns: 1fr auto 1fr;
		align-items: center;
		padding: 0 1.5rem;
		column-span: 3;
	}
	.pagination-footer > span {
		display: block;
		text-align: center;
		padding: 0 1rem;
		min-width: max-content;
	}
	div:last-child {
		display: flex;
		justify-content: flex-end;
	}
	a {
		text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    @media (max-width: theme('screens.sm')) {
    	position: absolute;
    	width: 100%;
    	height: 100%;
    	top: 0;
    	left: 0;
    	span {
    		display: none;
    	}
    }
	}
	:global(main) {
		padding-bottom: 0 !important;
		background: white !important;
	}
</style>
